export default [
  {
    path: "/about/suaw",
    name: "About",
    alias: ["/resources/about", "/about", "/about/about-suaw"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/about-suaw";
    }
  },
  {
    path: "/about/method",
    name: "Method",
    alias: ["/resources/method"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/method";
    }
  },
  {
    path: "/resources/get-involved",
    name: "GetInvolved",
    alias: ["/about/get-involved"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/get-involved";
    }
  },
  {
    path: "/resources/faq",
    name: "Faq",
    alias: ["/about/faq", "/faq"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/faq";
    }
  },
  {
    path: "/resources/contact",
    name: "Contact",
    alias: ["/contact"],
    beforeEnter() {
      window.location.href = "https://www.shutupwrite.com/contact";
    }
  }
];
